import { Component, HostListener } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { Popover, PopoverModule } from 'primeng/popover';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ToastModule } from 'primeng/toast';
import { Router } from '@angular/router';
import { UserService } from '../../pages/service/user.service';
import { AuthGuard } from '../../auth.guard';
import { DialogModule } from 'primeng/dialog';
import { environment } from '../../../environments/environment';
import { ProductService } from '../../pages/service/product.service';
import { InMemoryStorageService } from '../../services/in-memory-storage.service';
import { LoaderService } from '../../services/loader.service';
import { getWarehouseQuickSwitchPresets, WarehouseQuickSwitchPreset } from '../../config/warehouse-quick-switch-presets';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator, PopoverModule, ButtonModule, OverlayPanelModule, ToastModule, DialogModule],
    providers: [MessageService],
    template: ` <div class="layout-topbar">
            <p-toast></p-toast>
            <div class="layout-topbar-logo-container">
                <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                    <i class="pi pi-bars"></i>
                </button>
                <a class="layout-topbar-logo">
                    <img src="assets/torna_logo.png" alt="Torna Logo" class="torna-logo torna-logo--topbar mr-7" />

                    <span class="font-bold text-4xl">GFT</span>
                </a>
            </div>

            <div class="layout-topbar-actions">
                <div class="layout-config-menu" style="display: flex; align-items: center; gap: 1rem;">
                    <!-- Company and Division Badges -->
                    <span *ngIf="envtext" style="margin-right: 0.5rem; min-width: 60px; text-align:center; display: inline-flex; align-items: center;">
                        <span style="margin-left: 0.5em; font-size: 0.95em; font-weight: bold;">Environment :- </span>
                        <span class="p-badge p-badge-info" style="font-size: 1em; padding: 0.2em 1em; background-color: #ef4444; color: #fff; border-radius: 5px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); font-weight: bold;">
                            {{ this.envtext }}
                        </span>
                    </span>
                    <span style="margin-right: 0.5rem; min-width: 60px; text-align:center; display: inline-flex; align-items: center;">
                        <span style="margin-left: 0.5em; font-size: 0.95em; font-weight: bold;">Company :- </span>
                        <span class="p-badge p-badge-info" style="font-size: 1em; padding: 0.2em 1em; background-color: #0ea5e9; color: #fff; border-radius: 5px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); font-weight: bold;">
                            {{ userService.getCompanyId() }}
                        </span>
                    </span>
                    <span style="margin-right: 0.5rem; min-width: 60px; text-align:center; display: inline-flex; align-items: center;">
                        <span style="margin-left: 0.5em; font-size: 0.95em; font-weight: bold;">Division :- </span>
                        <span class="p-badge p-badge-success" style="font-size: 1em; padding: 0.2em 1em; background-color: #22c55e; color: #fff; border-radius: 5px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); font-weight: bold;">
                            {{ userService.getDivisionId() }}
                        </span>
                    </span>
                    <span style="margin-right: 1rem; min-width: 60px; text-align:center; display: inline-flex; align-items: center;">
                        <span style="margin-left: 0.5em; font-size: 0.95em; font-weight: bold;">Warehouse :- </span>
                        <span class="p-badge p-badge-info" style="font-size: 1em; padding: 0.2em 1em; background-color: #a855f7; color: #fff; border-radius: 5px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); font-weight: bold;">
                            {{ getWarehouseId() }}
                        </span>
                    </span>
                    <!-- Theme Toggle Button -->
                    <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()" style="margin-right: 0.5rem;" [title]="layoutService.isDarkTheme() ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
                        <i
                            class="pi"
                            [ngClass]="{
                                'pi-sun': layoutService.isDarkTheme(),
                                'pi-moon': !layoutService.isDarkTheme()
                            }"
                        ></i>
                    </button>
                    <div class="relative">
                        <button
                            class="layout-topbar-action layout-topbar-action-highlight"
                            pStyleClass="@next"
                            enterFromClass="hidden"
                            enterActiveClass="animate-scalein"
                            leaveToClass="hidden"
                            leaveActiveClass="animate-fadeout"
                            [hideOnOutsideClick]="true"
                        >
                            <i class="pi pi-palette"></i>
                        </button>
                        <app-configurator />
                    </div>
                </div>

                <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                    <i class="pi pi-ellipsis-v"></i>
                </button>

                <div class="layout-topbar-menu hidden lg:block">
                    <div class="layout-topbar-menu-content">
                        <!-- <button type="button" class="layout-topbar-action">
                        <i class="pi pi-calendar"></i>
                        <span>Calendar</span>
                    </button> -->
                        <!-- <button type="button" class="layout-topbar-action">
                        <i class="pi pi-inbox"></i>
                        <span>Messages</span>
                    </button> -->
                        <div class="layout-topbar-action">
                            <!-- Plain Icon Button -->
                            <button type="button" (click)="toggleOverlay(op, $event)" style="background: transparent; border: none; cursor: pointer;">
                                <i class="pi pi-user"></i>
                            </button>

                            <!-- Overlay Panel -->
                            <p-overlayPanel #op [style]="{ width: '280px' }" [dismissable]="true">
                                <div class="p-2">
                                    <button pButton type="button" label="View Profile" class="w-full mb-2" (click)="viewProfile()"></button>
                                    <div *ngIf="canUseQuickSwitch" style="font-size: 0.8rem; margin-bottom: 0.35rem; opacity: 0.85;">Quick Warehouse Switch</div>
                                    <div *ngIf="canUseQuickSwitch" style="display: flex; flex-wrap: wrap; gap: 0.35rem; margin-bottom: 0.5rem;">
                                        <button
                                            *ngFor="let preset of warehouseQuickPresets"
                                            pButton
                                            type="button"
                                            [label]="preset.label"
                                            severity="secondary"
                                            [disabled]="switchBusy"
                                            (click)="quickSwitch(preset)"
                                            style="flex: 1 1 30%; min-width: 4.25rem;"
                                        ></button>
                                    </div>
                                    <button pButton type="button" label="Logout" class="w-full" severity="danger" (click)="logout()"></button>
                                </div>
                            </p-overlayPanel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Logout Confirmation Dialog -->
        <p-dialog [(visible)]="showLogoutDialog" [style]="{ width: '350px' }" header="Logout Confirmation" [modal]="true" [closable]="false">
            <div class="p-d-flex p-ai-center p-jc-center" style="text-align: center;">
                <p>Are you sure you want to logout?</p>
            </div>
            <ng-template pTemplate="footer">
                <button pButton label="Yes" icon="pi pi-check" (click)="confirmLogout()" class="p-button-danger"></button>
                <button pButton label="No" icon="pi pi-times" (click)="cancelLogout()" class="p-button-secondary"></button>
            </ng-template>
        </p-dialog>`,
    styles: [
        `
            @media (max-width: 768px) {
                .layout-topbar {
                    flex-wrap: wrap;
                    align-items: flex-start;
                    row-gap: 0.35rem;
                    padding-inline: 0.35rem;
                    min-height: auto;
                }
                .layout-topbar-logo-container {
                    flex: 1 1 auto;
                    min-width: 0;
                    max-width: 100%;
                }
                .layout-topbar-logo {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0.25rem;
                    min-width: 0;
                }
                .layout-topbar-logo img.torna-logo--topbar {
                    height: 4.55rem !important;
                    margin-right: 0.35rem !important;
                }
                .layout-topbar-logo .text-4xl {
                    font-size: 1.35rem !important;
                    line-height: 1.1 !important;
                }
                .layout-topbar-actions {
                    flex: 1 1 100%;
                    width: 100%;
                    min-width: 0;
                    justify-content: flex-end;
                }
                .layout-config-menu {
                    flex-wrap: wrap !important;
                    justify-content: flex-end !important;
                    gap: 0.35rem !important;
                    row-gap: 0.25rem !important;
                    width: 100%;
                }
                .layout-config-menu > span {
                    min-width: 0 !important;
                    flex: 0 1 auto;
                }
            }
        `
    ]
})
export class AppTopbar {
    items!: MenuItem[];
    overlayPanelRef: any;
    company: string = '';
    division: string = '';
    switchBusy = false;
    private readonly defaultCompany = environment.production ? '080' : '782';
    readonly warehouseQuickPresets = getWarehouseQuickSwitchPresets(this.defaultCompany);
    private readonly skipReloadPromptKey = 'skipReloadPrompt';
    private readonly allowedEmailDomain = 'ssktech.co.in';

    constructor(
        public layoutService: LayoutService,
        public router: Router,
        public userService: UserService,
        private authService: AuthGuard,
        private productService: ProductService,
        private inMemoryStorageService: InMemoryStorageService,
        private loaderService: LoaderService,
        private messageService: MessageService
    ) {
        console.log('environment.production', environment.production);
        this.environmentConfig();
        // Get company and division from localStorage userProfile
    }
    envtext: any = '';
    environmentConfig() {
        console.log('environment.production123', environment.production);

        if (!environment.production) {
            console.log('Non-production environment detected');
            this.envtext = 'DEV';
        }
    }

    /** Current warehouse from session (set at login / quick switch / profile save). */
    getWarehouseId(): string {
        const raw = this.inMemoryStorageService.get('warehouseId');
        if (raw === null || raw === undefined) {
            return '';
        }
        return String(raw).replace(/^"(.*)"$/, '$1');
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
    toggleOverlay(panel: any, event: Event) {
        this.overlayPanelRef = panel;
        panel.toggle(event);
    }

    viewProfile() {
        console.log('View Profile clicked');
        console.log(this.overlayPanelRef);

        if (this.overlayPanelRef) {
            this.overlayPanelRef.hide();
        }

        this.router.navigate(['/view-profile']);
        // Your profile logic
    }

    quickSwitch(preset: WarehouseQuickSwitchPreset) {
        if (!this.canUseQuickSwitch) {
            return;
        }
        if (this.switchBusy) {
            return;
        }

        let username = this.userService.getUserName();
        if (!username) {
            const localUser = localStorage.getItem('userName');
            username = localUser ? localUser.replace(/^"(.*)"$/, '$1') : '';
        }
        if (!username) {
            return;
        }

        this.switchBusy = true;
        this.loaderService.show('Switching warehouse...', 'Applying company / division / facility / warehouse');
        this.userService.getUserProfile(username).subscribe({
            next: (profile) => {
                this.userService
                    .updateUserProfile({
                        userName: profile.userName,
                        mobile: profile.mobile,
                        m3ResponsibleId: profile.m3ResponsibleId,
                        company: preset.company,
                        division: preset.division,
                        facility: preset.facility,
                        warehouse: preset.warehouse
                    })
                    .subscribe({
                        next: () => {
                            this.syncCompanyDivisionContext(preset.company, preset.division, preset.facility, preset.warehouse);
                            this.switchBusy = false;
                            this.loaderService.hide();
                            if (this.overlayPanelRef) {
                                this.overlayPanelRef.hide();
                            }
                            // Force full app re-initialization so all country-dependent views/features refresh.
                            sessionStorage.setItem(this.skipReloadPromptKey, 'true');
                            window.location.reload();
                        },
                        error: () => {
                            this.switchBusy = false;
                            this.loaderService.hide();
                        }
                    });
            },
            error: () => {
                this.switchBusy = false;
                this.loaderService.hide();
            }
        });
    }

    private syncCompanyDivisionContext(company: string, division: string, facility: string, warehouse: string) {
        this.userService.setCompanyAndDivision(company, division);
        this.productService.setCompanyAndDivision(company, division);
        this.inMemoryStorageService.set('company', company);
        this.inMemoryStorageService.set('division', division);
        this.inMemoryStorageService.set('companyId', company);
        this.inMemoryStorageService.set('divisionId', division);
        this.inMemoryStorageService.set('facilityId', facility);
        this.inMemoryStorageService.set('warehouseId', warehouse);
    }

    get canUseQuickSwitch(): boolean {
        const emailValue = this.inMemoryStorageService.get('email') || localStorage.getItem('email') || '';
        const email = String(emailValue).replace(/^"(.*)"$/, '$1').toLowerCase();
        const hasAllowedEmail = email.includes(`@${this.allowedEmailDomain}`) || email.endsWith(this.allowedEmailDomain);

        const rawRoles = this.inMemoryStorageService.get('roleGroup') || localStorage.getItem('roleGroup') || '[]';
        let roles: string[] = [];
        try {
            roles = Array.isArray(rawRoles) ? rawRoles : JSON.parse(String(rawRoles));
        } catch {
            roles = [];
        }

        const hasManagerRole = roles.some((role) => String(role).toLowerCase().includes('manager'));
        const hasSuperUserRole = roles.some((role) => String(role).toLowerCase() === 'admin_group');

        if (hasSuperUserRole) {
            return true;
        }
        return hasAllowedEmail && hasManagerRole;
    }
    showLogoutDialog = false;

    @HostListener('window:keydown', ['$event'])
    onWindowKeydown(event: KeyboardEvent): void {
        if (!event.altKey || (event.key !== 'l' && event.key !== 'L')) {
            return;
        }
        if (this.router.url?.startsWith('/login')) {
            return;
        }
        event.preventDefault();
        this.logout();
    }

    logout() {
        if (this.blockLogoutIfBusy()) {
            return;
        }
        this.showLogoutDialog = true;
    }
    cancelLogout() {
        this.showLogoutDialog = false;
    }
    confirmLogout() {
        if (this.blockLogoutIfBusy()) {
            this.showLogoutDialog = false;
            return;
        }
        this.showLogoutDialog = false;
        this.authService.logout();
    }

    private blockLogoutIfBusy(): boolean {
        if (!this.loaderService.isAnyUiLoaderActive()) {
            return false;
        }
        this.messageService.add({
            severity: 'warn',
            summary: 'Please wait',
            detail: 'Please wait until the current operation finishes.',
            life: 3500
        });
        return true;
    }
}
